import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import Vue from 'vue';

interface RelatedLearningPathState {
  info?: RelatedLearningPathInfo;
}

const relatedLearningPathInfo: Module<RelatedLearningPathState, RootState> = {
  namespaced: true,
  state: {
    info: undefined,
  },
  getters: {
    learningPath: state => state.info,
  },
  mutations: {
    setValue(state: RelatedLearningPathState, value: RelatedLearningPathInfo): void {
      Vue.set(state, 'info', value);
    },
  },
};

export default relatedLearningPathInfo;
